import { BoxProps, Stack } from '../index';
import { SelectableButton, SelectableButtonProps } from './SelectableButton';

export interface SelectableButtonChecklistProps {
  /**
   * Array of objects, one for each button. Each object contains the following properties: text, selected, onClick, onHover
   */
  items: SelectableButtonProps[];
  /**
   * Controls the gap between the buttons
   */
  gap?: BoxProps['gap'];
}

export const SelectableButtonChecklist = ({
  items,
  gap = 'xsmall',
}: SelectableButtonChecklistProps): JSX.Element => {
  const btnElements = items.map((item, i) => (
    <SelectableButton key={`selectable-button-number-${i}`} {...item} />
  ));

  return <Stack gap={gap}>{btnElements}</Stack>;
};
